import { isString, isFunction } from 'lodash';

function getRowKey(row, rowKey) {
  if (row === void 0) {
    row = {};
  }
  if (isString(rowKey) && row) {
    return row[rowKey];
  }
  if (isFunction(rowKey) && row) {
    return rowKey(row);
  }
  return undefined;
}

export { getRowKey as default };
